(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-collection-header"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var toggleLink = document.getElementById('toggle-description-link');
    var truncatedDesc = document.getElementById('truncated-description');
    var fullDesc = document.getElementById('full-description');

    toggleLink.addEventListener('click', function(event) {
      event.preventDefault();
      var isExpanded = toggleLink.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // truncatedDesc.style.display = '';
        // fullDesc.style.display = 'none';
        // toggleLink.textContent = 'Read More';
        // toggleLink.setAttribute('aria-expanded', 'false');
        // toggleLink.removeAttribute('href');
        // toggleLink.removeAttribute('aria-label');
        // scroll to more info section
        window.location.href = '#more-info';
      } else {
        truncatedDesc.style.display = 'none';
        fullDesc.style.display = '';
        toggleLink.textContent = 'View all information';
        toggleLink.setAttribute('aria-expanded', 'true');
        toggleLink.setAttribute('href', '#all-info');
        toggleLink.setAttribute('aria-label', 'View all information and jump to all info section');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
